import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-validar-ticket',
  templateUrl: './validar-ticket.component.html',
  styleUrls: ['./validar-ticket.component.css']
})
export class ValidarTicketComponent implements OnInit, OnDestroy {
  id: string;
  estado: 'cargando' | 'valido' | 'invalido' = 'cargando';
  data: Array<any> = [];
  private sub: Subscription;

  constructor(private route: ActivatedRoute, private dataService: HttpService) { }

  ngOnInit(): void {
    this.sub = this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.validar();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private validar() {
    this.data = [];
    if (!this.id) {
      this.estado = 'invalido';
      return;
    }
    this.estado = 'cargando';
    this.dataService.validarTicket(this.id).subscribe(result => {
      let tabla = !result || result['hasError'] ? null : result['result'] && result['result']['data'] && result['result']['data']['table0'];
      if (tabla && tabla.length > 0) {
        this.data = tabla;
        this.estado = 'valido';
      } else {
        this.estado = 'invalido';
      }
    }, () => {
      this.estado = 'invalido';
    });
  }
}
